export const REDIRECT_TO_STUDIO_WORKSPACE = {
  name: "StudioWorkspace",
  i18nKey: "editor.goBack",
};
